import React from 'react';
import {useInternationalization} from "@progress/kendo-react-intl";

import {ITableCell} from "../../../types/ITableCell";

const DateCell:React.FC<ITableCell> = (props) => {
  const intl = useInternationalization();

  return (
    <td {...props.tdProps} style={props.style} className={props.className}>
      {props.field && props.dataItem[props.field] && intl.formatDate(new Date(props.dataItem[props.field]),'d')}
    </td>
  );
};

export default DateCell;